// SubareasService.js
import http from './Http';

const generarSubareas = async (n, nivel_id, grado_id, area_id) => {
  try {
    const response = await http.post('/sae/prompt/generar-subareas', {
      n,
      nivel_id,
      grado_id,
      area_id
    });
    // 🔒 Validación defensiva del contrato
    if (
      !response?.data ||
      !Array.isArray(response.data.resultado)
    ) {
      throw new Error('Respuesta inválida al generar subáreas');
    }
    
    return response.data;
  } catch (error) {
    console.error('Error generating subareas:', error);
    throw error;
  }
};

const generarTemas = async (n, nivel_id, grado_id, area_id, sub_area_tematica) => {
  try {
    const response = await http.post('/sae/prompt/generar-temas', {
      n,
      nivel_id,
      grado_id,
      area_id,
      sub_area_tematica
    });
    return response.data;
  } catch (error) {
    console.error('Error generating temas:', error);
    throw error;
  }
};

const SubareasService = {
  generarSubareas,
  generarTemas,
};

export default SubareasService;
